'use client'

import React, { useState } from 'react'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import { useSelector } from 'react-redux'
import { selectProfile } from '@/store/user/slice'
import ArrowIcon from '@/components/Shared/ArrowIcon'
import styles from './styles.module.scss'
import clsx from 'clsx'

const ProfileNav: React.FC = () => {
  const _pathname = usePathname()
  const searchParams = useSearchParams()
  const profile = useSelector(selectProfile)
  const [isExpanded, setIsExpanded] = useState(false)

  // 学生判定（1: 学生, 2: 社会人）
  const isStudent = profile?.job === 1

  const navItems = [
    {
      title: 'アカウント',
      items: [{ name: 'アカウント情報', type: 'account' }],
    },
    {
      title: 'プロフィール',
      items: [
        { name: '基本情報', type: 'basic' },
        { name: '学歴', type: 'education' },
        { name: '職歴', type: 'career', hideForStudent: true },
        { name: '希望条件', type: 'preference' },
      ],
    },
    {
      title: '通知',
      items: [{ name: 'メール通知設定', type: 'notification' }],
    },
  ]

  const currentType = searchParams.get('type') || 'account'

  const toggleMenu = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <nav className={clsx(styles.profileNav, { [styles.expanded]: isExpanded })}>
      {/* SP */}
      <button className={styles.mobileToggle} onClick={toggleMenu}>
        <ArrowIcon isExpanded={isExpanded} className={styles.toggleArrow} />
        <span className={styles.toggleText}>
          {isExpanded ? 'メニューを閉じる' : 'プロフィール・設定メニュー'}
        </span>
      </button>

      {/* PC */}
      <div className={clsx(styles.navContent, { [styles.show]: isExpanded })}>
        {navItems.map((section) => (
          <div key={section.title} className={styles.navSection}>
            <h3 className={styles.navTitle}>{section.title}</h3>
            <ul className={styles.navList}>
              {section.items
                .filter((item) => !(item.hideForStudent && isStudent))
                .map((item) => (
                  <li key={item.name} className={styles.navItem}>
                    <Link
                      href={`/members/profile?type=${item.type}`}
                      className={clsx(styles.navLink, {
                        [styles.active]: currentType === item.type,
                      })}
                      onClick={() => setIsExpanded(false)}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>
    </nav>
  )
}

export default ProfileNav
